var map = {
	"./addImage.png": 16802,
	"./addImage.svg": 41710,
	"./addImageRed.png": 66477,
	"./addImageRed.svg": 42939,
	"./archive.png": 98530,
	"./archive.svg": 46252,
	"./arrow-down.svg": 30222,
	"./check.svg": 53658,
	"./check_green.svg": 16366,
	"./coin.png": 53049,
	"./comment.png": 30679,
	"./comment.svg": 54881,
	"./copy.svg": 73761,
	"./editPaper.png": 42994,
	"./editPaper.svg": 5668,
	"./edit_step.svg": 46015,
	"./error.svg": 19864,
	"./lock.svg": 88355,
	"./open_in_new.svg": 27619,
	"./password.png": 65981,
	"./password.svg": 53073,
	"./pdf.png": 42090,
	"./pdf.svg": 99508,
	"./preview-green.svg": 65844,
	"./preview.png": 1428,
	"./preview.svg": 92798,
	"./refreshCode.svg": 7076,
	"./supplier.png": 28518,
	"./supplier.svg": 34370,
	"./update.png": 52037,
	"./update.svg": 51237
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16400;